<script setup lang="ts">
import { useFormatDate } from '@modules/core/composables/datetime';
import {
  useDashboardFilters,
  useDashboardTranslationGroup,
} from '@modules/dashboard/composables';
import { useDashboardLastUpdateQuery } from '@modules/dashboard/queries';

const { translationGroup } = useDashboardTranslationGroup();
const { formatDate } = useFormatDate();
const { merchantId } = useDashboardFilters();

const { data: dashboardLastUpdated } = useDashboardLastUpdateQuery(merchantId);
</script>

<template>
  <div v-data-qa-auto-id="'TheDashboardLastUpdate'"
    :class="{ invisible: !dashboardLastUpdated }"
    class="text-muted-color"
  >
    <span>
      {{ $getTranslation(translationGroup, 'LAST_UPDATE') }}&nbsp;
    </span>
    <span
      v-if="dashboardLastUpdated"
      class="font-bold"
    >
      {{ formatDate(dashboardLastUpdated, 'PPPp') }}
    </span>
  </div>
</template>
